import React from 'react';
import {
  AdvertBanner as IAdvertBanner,
  Gallery as IGallery,
} from '../../../models/course/ICourseContent';
import { ICoursePageSettings as IBranding } from '../../../models/course/ICoursePageSettings';
import { checkAdvertBannerContentExists } from '../../../utils/advert-banner/advert-banner-content';
import MediaGalleryComponentModel from '../../../models/components/media-gallery-component-model';
import { ApplicationBranding } from '../../../models/settings';
import { ApplicationType } from '../../../constants/application-type';
import { MediaAssetType } from '../../../constants/media-asset-type';
import AdvertBanner from '../advert-banner/advert-banner';
import MediaGallery from '../media-gallery/media-gallery';

export type MediaSectionProps = {
  application: string;
  advertSection: IAdvertBanner;
  gallerySection: IGallery;
  gallerySectionTitle: string;
  mediaSectionType: string;
  branding: IBranding;
};

export default function MediaSection({
  application,
  advertSection,
  gallerySection,
  gallerySectionTitle,
  mediaSectionType,
  branding,
}: MediaSectionProps) {
  // check if advert banner data exist
  let checkAdvertExists = checkAdvertBannerContentExists(advertSection?.fields);

  // construct media gallery data
  let mediaGalleryComponent: any;
  if (gallerySection?.fields?.gallery) {
    mediaGalleryComponent = new MediaGalleryComponentModel(gallerySection?.fields, null);
  }

  const ctaBranding: ApplicationBranding = {
    primaryColor: branding.backgroundColor,
    primaryHoverColor: branding.hoverBackgroundColor,
    primaryActiveColor: branding.activeBackgroundColor,
  };

  const canShowAdvert =
    checkAdvertExists &&
    (application === ApplicationType.PartnerPortal ||
      application === ApplicationType.UniBrandedB2c) &&
    (mediaSectionType === MediaAssetType.AdvertBanner || mediaSectionType === MediaAssetType.Both);

  const canShowGallery =
    mediaGalleryComponent &&
    (mediaSectionType === MediaAssetType.MediaGallery || mediaSectionType === MediaAssetType.Both);

  return (
    <>
      {canShowAdvert && advertSection?.fields && (
        <div className='mb-md-5 mb-3' id='advert-banner-section'>
          <AdvertBanner
            advertBanner={advertSection.fields}
            appBranding={ctaBranding}
            application={application}
          />
        </div>
      )}
      {canShowGallery && (
        <div className='row' id='media-gallery-section'>
          <div className='col-md-12 gallery'>
            <h3 className='mb-3'>{gallerySectionTitle}</h3>
            <MediaGallery
              galleryItems={mediaGalleryComponent.gallery}
              hash={typeof window !== 'undefined' ? window.location?.hash : null}
            />
          </div>
        </div>
      )}
    </>
  );
}
